module.exports = __webpack_public_path__ + "img/8.62f6f45d.png";